import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '../../../../shared/text-area';
import defaultOnErrorHandler from '../../../../../shared/default-on-error-handler';
import { usePostUpdateAccred } from '../../../../../services/profiles/contributor-settings-service';

export default function Accred({ value }) {
  const [{ loading, error }, post] = usePostUpdateAccred();

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving accreditation and awards');
  }, [error]);

  const taProps = {
    value,
    label: 'your accreditation & awards',
    limit: 280,
    isLoading: loading,
    onChange: post,
  };

  return (
    <article>
      <TextArea {...taProps} />
    </article>
  );
}

Accred.propTypes = {
  value: PropTypes.string,
};

Accred.defaultProps = {
  value: null,
};
